<template>
  <transition name="el-fade-in-linear">
    <div
      v-show="dialogVisible"
      class="popContainer indiv-pop"
      @click.self="onMaskClick"
    >
      <div class="indiv-pop-center">
        <span
          class="indiv-pop-close iconfont icon-close_round_fill_bold"
          role="button"
          aria-label="关闭"
          @click="onClose"
        ></span>
        <div class="indiv-pop-box" :style="boxStyle">
          <div class="indiv-pop-title">
            <slot name="title">{{ title }}</slot>
          </div>
          <div class="indiv-pop-body indiv-pop-body--form">
            <slot></slot>
          </div>
          <div v-if="$slots.footer" class="indiv-pop-foot">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FormDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: 560,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },

    dialogWidth() {
      const width = this.width;
      if (typeof width === 'number') {
        return `${width}px`;
      }
      return width;
    },

    boxStyle() {
      return { width: this.dialogWidth };
    },
  },

  methods: {
    onClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    onMaskClick() {
      if (this.closeOnClickModal) {
        this.onClose();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/formDialog/FormDialog.vue